<template>
    <div ref="record">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                    <!-- <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">通过状态</span>
                        <el-select size="mini" v-model="searchParam.state" clearable placeholder="请选择" class="handle-select" >
                            <el-option key="0" label="未通过" value="4"></el-option>
                            <el-option key="1" label="已通过" value="3"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">考试次数</span>
                        <el-input-number size="mini" v-model="searchParam.times" :min="0" controls-position="right" class="handle-input"></el-input-number>
                    </el-col> -->
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">姓&emsp;&emsp;名</span>
                        <el-input size="mini" v-model="searchParam.chName" label="姓名" placeholder="姓名" clearable @clear="searchParam.chName = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">姓名拼音</span>
                        <el-input size="mini" v-model="searchParam.enName" label="姓名" placeholder="姓名" clearable @clear="searchParam.enName = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">学员邮箱</span>
                        <el-input size="mini" v-model="searchParam.email" placeholder="学员邮箱" clearable @clear="searchParam.email = null" class="handle-input"></el-input>
                    </el-col>
                    <!-- <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">培训机构</span>
                        <el-input size="mini" v-model="searchParam.institutions" placeholder="培训机构" clearable @clear="searchParam.tel = null" class="handle-input"></el-input>
                    </el-col> -->
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">科&emsp;&emsp;目</span>
                        <el-select size="mini" v-model="searchParam.subjectId" clearable placeholder="科目">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <!-- <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">成绩范围</span>
                        <el-select size="mini" v-model="searchParam.level" clearable placeholder="请选择" class="handle-select" @change="changeLevel" @clear="clearLevel">
                            <el-option v-for="item in levelData" :key="item.value" :label="item.name" :value="item"></el-option>
                        </el-select>
                    </el-col> -->
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="8">
                        <span class="label">创建时间</span>
                        <el-date-picker
                            size="mini"
                            style="width:200px"
                            v-model="searchParam.startTime"
                            type="datetime"
                            placeholder="开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                        <span class="label" style="margin:0 5px;">至</span>
                        <el-date-picker
                            size="mini"
                            style="handle-input"
                            v-model="searchParam.endTime"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-download" @click="exportRecord">导出</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen">
                <el-table-column prop="certificateNo" label="证书编号"  width="200" fixed="left"></el-table-column>
                <el-table-column prop="subject.name" label="科目" ></el-table-column>
                <el-table-column prop="chName" label="姓名"  width="120"></el-table-column>
                <el-table-column prop="enName" label="姓名拼音"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
                <el-table-column prop="awardTime" label="颁证日期" width="150" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150" align="center"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="edit(scope.$index, scope.row)">编辑</el-button>
<!--                        <el-button size="small" type="danger" @click="editFrequency(scope.$index, scope.row)">授权</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%" @closed="clearValidate('editForm')">
            <el-form ref="editForm" :model="editForm" :rules="updateCertificateRules" label-width="100px">
                <el-form-item label="邮  箱" prop="email">
                    <el-input v-model="editForm.email"></el-input>
                </el-form-item>
                <el-form-item label="姓  名" prop="chName">
                    <el-input v-model="editForm.chName"></el-input>
                </el-form-item>
                <el-form-item label="姓名拼音">
                    <el-input v-model="editForm.enName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name:'record',
        data() {
            return {
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:10,
                },
                subjectList: [],
                tableData:[],
                totalNumber:0,
                editForm:{},
                editVisible:false,
                updateCertificateRules:{
                    email:[{required: true, message: '请输入邮箱', trigger: 'blur'}],
                    chName:[{required: true, message: '请输入姓名', trigger: 'blur'}],
                },
            };
        },
        created(){
            this.getSubjectList();
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getData(){
                let res = await this.$axios.post('/manage/certificate/selectByPage',this.searchParam);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            },
            async getSubjectList() {
                let res = await this.$axios.get("/manage/subject/selectAll");
                if (res.code == 200) {
                    this.subjectList = res.data;
                }
            },
            edit(index, row) {
                this.editForm = this.$ObjectUtil.cloneObj(row);
                this.editVisible = true;
            },
            clearValidate(form) {
                this.$refs[form].clearValidate();
            },
            // 保存编辑
            async saveEdit() {
                let valid = await this.$refs.editForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }

                let res = await this.$axios.post('/manage/certificate/update',this.editForm);
                console.log(res)
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.$refs.editForm.resetFields();
                this.editVisible = false;
                this.$message.success("保存成功");
                this.getData();
            },
            async exportRecord() {
                let res = await this.downloadPost('/manage/certificate/exportCertificate', this.searchParam);
                if (res.code != 200) {
                    this.$message.error(`导出失败${res.errMsg}`);
                }
            },
        }
    };
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-col{
    margin: 10px 0;
}
/* .handle-select {
    width: 200px;
}

.handle-input {
    width: 200px;
} */
.label {
    margin-right: 10px;
    color: #606266;
}
</style>
